import { SALESFORCE_WIZARD_PENDO_TRACK_NAME } from './consts';

export const trackPendoEvent = (event) => {
  if (window.pendo && event) {
    window.pendo.track(`${SALESFORCE_WIZARD_PENDO_TRACK_NAME} | ${event}`);
  }
};

/*
ihubShell
ihubWorkatoIntegration
ihubMedalliaAdaptor
ihubCrmwExplorer
ihubCrmwData
ihubCrmwConfig
*/

export const getCSDSDomain = service => window.LE.sessionManager.LEConfig[service];
